export function formatDayISO(day) {
  const date = day instanceof Date ? day : new Date(day);
  const utcDate = new Date(Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  ));
  return utcDate.toISOString();
}

export function getActivityUserIds(activity) {
  if (!activity?.users || !Array.isArray(activity.users)) {
    return [];
  }
  return [...new Set(activity.users.filter(Boolean))];
}

import { isDateOnOrAfterToday, parseDateAbsolute, parseDateParts } from '@/utils/dateUtils';

export function formatActivityDate(startDate) {
  if (startDate instanceof Date) {
    const year = startDate.getFullYear();
    const month = String(startDate.getMonth() + 1).padStart(2, '0');
    const day = String(startDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const parts = parseDateParts(startDate);
  if (parts) {
    return `${parts.year}-${String(parts.month).padStart(2, '0')}-${String(parts.day).padStart(2, '0')}`;
  }

  return '';
}

export function resolveRecurringTemplate(activity, activities = []) {
  if (!activity) {
    return null;
  }
  if (!activity.startDate) {
    return activity;
  }
  if (!activity.relatedActivity) {
    return null;
  }
  return activities.find((item) => item._id === activity.relatedActivity) || null;
}

export function isRecurringSeriesActivity(activity, day = null) {
  if (!activity) {
    return false;
  }
  if (!activity.startDate && day) {
    return true;
  }
  return Boolean(activity.relatedActivity);
}

export function getFutureSeriesActivities(activities, template) {
  if (!template?._id) {
    return [];
  }

  return activities.filter((item) => {
    if (item._id === template._id) {
      return true;
    }
    if (item.relatedActivity !== template._id || !item.startDate) {
      return false;
    }
    return isDateOnOrAfterToday(item.startDate);
  });
}

export function isRecurringSkipMarker(activity) {
  return Boolean(activity?.cancelled && activity?.relatedActivity && activity?.startDate);
}

export function buildRecurringSkipMarker(template, day) {
  const dayDate = day instanceof Date ? day : new Date(day);
  return {
    name: template.name,
    startTime: template.startTime,
    endTime: template.endTime || '',
    startDate: formatActivityDate(dayDate),
    consumequota: template.consumequota,
    cupos: template.cupos,
    registration: false,
    planningId: template.planningId,
    stablishmentId: template.stablishmentId,
    day: template.day,
    relatedActivity: template._id,
    cancelled: true,
  };
}

export function hasSkipMarkerForDate(activities, templateId, day) {
  const dateStr = formatActivityDate(day);
  return activities.some((activity) => {
    if (!isRecurringSkipMarker(activity)) return false;
    if (activity.relatedActivity !== templateId) return false;
    return formatActivityDate(activity.startDate) === dateStr;
  });
}
